import React, {Component} from 'react'
import ReactDOM from 'react-dom';
import MediaFilterAction from './MediaFilterAction'

class MediaTopBar extends Component {

  constructor(props) {
    super(props);
  }

  handleSearchTextChange(e){
    e.preventDefault();
    this.props.onHandleSearchText(e.target.value)
  }

  handleChangeFiler(e){
    e.preventDefault();
    this.props.onFilterChange(e.target.value)
  }

  handleCreateFolder(folder_name){

    let folder;
    let folderName = this.props.filtered + '/' + folder_name;

    jQuery.ajax({
      type: "POST",
      url: pagebuilder_base + 'index.php?option=com_sppagebuilder&task=media.create_folder',
      data: {folder: folderName },
      cache: false,
      async: false,
      success: function(response) {
        try {
          var data = jQuery.parseJSON(response)
          if(data.status) {
            folder = data;
          } else {
            alert(data.output)
          }
        } catch (e) {
          jQuery('.sp-pagebuilder-media-body-inner').html(response)
        }
      }
    })

    if (typeof folder.status !== 'undefined' && folder.status) {
      this.props.onCreateFolder(folder.output);
    }
  }

  render(){
    var customStyle = { display: 'none' }

    return(
      <div className="sp-pagebuilder-media-toolbar clearfix">
        <div id="sp-pagebuilder-media-tools" className="pull-left clearfix">
          {
            this.props.activeItem == '' &&
            <div>
              <div>
                <input
                  type="file"
                  id="sp-pagebuilder-media-input-file"
                  style={ customStyle }
                  ref="mediaInput"
                  onChange={(e)=>{
                    let files = this.refs.mediaInput.files[0];
                    this.props.onHandleUpload(files);
                  }}
                />
                <a
                  href="#"
                  className="sp-pagebuilder-btn sp-pagebuilder-btn-success"
                  onClick={(e)=>{
                    e.preventDefault();
                    this.refs.mediaInput.click();
                  }}
                >
                  <i className="fa fa-upload"></i><span className="hidden-phone hidden-xs"> Upload Files</span>
                </a>
              </div>
              {
                this.props.typeOfMedia != 'folders' &&
                <div>
                  <div className="sp-pagebuilder-media-search">
                    <i className="fa fa-search"></i>
                    <input
                      type="text"
                      ref="searchTextRef"
                      className="sp-pagebuilder-form-control"
                      onKeyUp={ this.handleSearchTextChange.bind(this)}
                    />
                    {
                      this.props.searchText !='' &&
                      <a
                        href="#"
                        className="sp-pagebuilder-clear-search"
                        onClick={(e)=>{
                          e.preventDefault();
                          ReactDOM.findDOMNode(this.refs.searchTextRef).value='';
                          this.props.onHandleSearchText('')
                        }}
                      >
                        <i className="fa fa-times-circle"></i>
                      </a>
                    }
                  </div>
                </div>
              }
            </div>
          }

          {
            this.props.activeItem !== '' &&
            <div>
              <a
                href="#"
                className="sp-pagebuilder-btn sp-pagebuilder-btn-success"
                onClick={(e)=>{
                  e.preventDefault();
                  this.props.onInsertMediaClick();
                }}
              >
                <i className="fa fa-check"></i> Insert
              </a>
              <a
                href="#" id="sp-pagebuilder-cancel-media"
                className="sp-pagebuilder-btn sp-pagebuilder-btn-default"
                onClick={(e)=>{
                  e.preventDefault();
                  this.props.onHandleItemClick('');
                }}
              >
                <i className="fa fa-times"></i> Cancel
              </a>
            </div>
          }
          {
            this.props.typeOfMedia == 'folders' &&
            <div>
              <a
                href="#"
                className="sp-pagebuilder-btn sp-pagebuilder-btn-primary"
                onClick={(e)=>{
                  e.preventDefault();
                  var folder_name = prompt(Joomla.JText._('COM_SPPAGEBUILDER_MEDIA_MANAGER_ENTER_DIRECTORY_NAME'));
                  if (folder_name == null) {
                    return;
                  }
                  folder_name = folder_name.trim();
                  if (folder_name != '') {
                    this.handleCreateFolder(folder_name);
                  }
                }}
              >
                <i className="fa fa-plus"></i> New Folder
              </a>
            </div>
          }
        </div>

        <div className="pull-right hidden-phone">
          {
            this.props.activeItem == '' &&
            <MediaFilterAction
              onFilterChange = { this.props.onFilterChange }
              typeOfMedia = { this.props.typeOfMedia }
              filtered = { this.props.filtered }
              filters = { this.props.filters }
            />
          }
          {
            this.props.activeItem !== '' &&
            <div>
              <a
                href="#"
                className="sp-pagebuilder-btn sp-pagebuilder-btn-danger hidden-xs"
                onClick={(e)=>{
                  e.preventDefault();
                  this.props.onHandleDeleteItem();
                }}
              >
                <i className="fa fa-minus-circle"></i> Delete
              </a>
            </div>
          }
        </div>

        <a
          href="#"
          className="sp-pagebuilder-btn-close-modal"
          onClick={(e)=>{
            e.preventDefault();
            this.props.onModalCloseClick()
          }}
        >
          <i className="fa fa-times"></i>
        </a>
      </div>
    )
  }
}

export default MediaTopBar;



// WEBPACK FOOTER //
// ./src/helpers/form/types/media-helper/MediaTopBar.js